import type { InputHTMLAttributes } from "react";
import { Input } from "../atoms/Input";
import { twMerge } from "tailwind-merge";

type PhoneNumberInputProps = {
  readonly id?: string;
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly onBlur?: () => void;
  readonly placeholder?: string;
  readonly className?: string;
  readonly inputClassName?: string;
} & Pick<InputHTMLAttributes<HTMLInputElement>, "aria-invalid" | "title">;

export const PhoneNumberInput = ({
  id,
  value,
  onChange,
  onBlur,
  placeholder = "Enter phone number",
  className,
  inputClassName,
  ...rest
}: PhoneNumberInputProps) => {
  return (
    <div className={twMerge("flex", className)}>
      <input
        type="text"
        value="+1"
        disabled
        readOnly
        tabIndex={-1}
        aria-hidden="true"
        className="w-14 shrink-0 cursor-default rounded-l-lg border border-r-0 border-gray-300 bg-gray-50 px-2 py-2 text-center text-sm text-gray-600"
      />
      <Input
        id={id}
        type="tel"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        className={twMerge("min-w-0 flex-1 rounded-l-none bg-white", inputClassName)}
        {...rest}
      />
    </div>
  );
};
